<div class="p-6 bg-gray-50 min-h-screen">
  <!-- Global Variables Section -->
  <div class="mb-8 bg-white rounded-lg shadow-sm">
    <div class="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
      <h2 class="text-xl font-semibold text-gray-800">Global Variables</h2>
      <button 
        class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md transition-colors flex items-center gap-2"
        (click)="changeAddGlobalVariableFlag()">
        <span class="text-lg">+</span> Add Variable
      </button>
    </div>
    
    <div class="p-4">
      <div *ngIf="getKeys(globalVariables).length === 0" class="text-gray-500 text-center py-4">
        No global variables added yet
      </div>
      
      <div *ngFor="let key of getKeys(globalVariables); trackBy: trackByValue" class="mb-2 p-3 border rounded-md hover:bg-gray-50">
        <div class="flex justify-between items-center">
          <div>
            <span class="font-medium text-gray-800">{{ key }}</span>
            <span class="text-gray-600 ml-2">:</span>
            
            <!-- Entity Type -->
            <span *ngIf="getDataType(globalVariables[key]) == 'ENTITY'" class="ml-2">
              <span class="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full">Entity</span>
              <span class="ml-2">{{ globalVariables[key].entityName }}</span>
            </span>
            
            <!-- Array of Objects Type -->
            <span *ngIf="getDataType(globalVariables[key]) == 'ARRAY_OF_OBJECT'" class="ml-2">
              <span class="bg-indigo-100 text-indigo-800 text-xs px-2 py-1 rounded-full">Entity List</span>
              <span class="ml-2">{{ globalVariables[key].entityName }}</span>
            </span>
            
            <!-- Other Types -->
            <span *ngIf="getDataType(globalVariables[key]) !== 'ENTITY' && getDataType(globalVariables[key]) !== 'ARRAY_OF_OBJECT'" class="ml-2">
              <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">{{getDataType(globalVariables[key])}}</span>
              <span class="ml-2">{{ globalVariables[key] }}</span>
            </span>
          </div>
          
          <!-- Add edit and delete buttons here if needed -->
        </div>
      </div>
    </div>
  </div>

  <!-- Entities Section -->
  <div class="mb-8 bg-white rounded-lg shadow-sm">
    <div class="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
      <h2 class="text-xl font-semibold text-gray-800">Entities</h2>
      <div class="flex items-center gap-3" *ngIf="filteredEntityList.length">
        <select
          class="border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
          [(ngModel)]="selectedNewEntity"
        >
          <option value="">Select Entity</option>
          <option *ngFor="let entity of filteredEntityList" [value]="entity.id">
            {{ entity.name }}
          </option>
        </select>

        <button
          class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md transition-colors flex items-center gap-2"
          (click)="addEntity()">
          <span class="text-lg">+</span> Add Entity
        </button>
      </div>
    </div>

    <div class="p-4">
      <div *ngIf="pageData.entites.length === 0" class="text-gray-500 text-center py-4">
        No entities added yet
      </div>

      <div *ngFor="let entity of pageData.entites" class="mb-2 p-3 border rounded-md hover:bg-gray-50">
        <div class="flex justify-between items-center">
          <div>
            <span class="font-medium text-gray-800">{{ entity }}</span>
            <span class="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full ml-2">Entity</span>
          </div>
          <!-- Add edit and delete buttons here if needed -->
        </div>
      </div>
    </div>
  </div>

  <!-- Local Page Variables Section -->
  <div class="mb-8 bg-white rounded-lg shadow-sm">
    <div class="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
      <h2 class="text-xl font-semibold text-gray-800">Local Page Variables</h2>
      <button 
        class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md transition-colors flex items-center gap-2"
        (click)="changeAddLocalVariableFlag()">
        <span class="text-lg">+</span> Add Variable
      </button>
    </div>
    
    <div class="p-4">
      <div *ngIf="getKeys(pageData.localVariable).length === 0" class="text-gray-500 text-center py-4">
        No local variables added yet
      </div>
      
      <div *ngFor="let key of getKeys(pageData.localVariable); trackBy: trackByValue" class="mb-2 p-3 border rounded-md hover:bg-gray-50">
        <div class="flex justify-between items-center">
          <div>
            <span class="font-medium text-gray-800">{{ key }}</span>
            <span class="text-gray-600 ml-2">:</span>
            
            <!-- Entity Type -->
            <span *ngIf="getDataType(pageData.localVariable[key]) == 'ENTITY'" class="ml-2">
              <span class="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full">Entity</span>
              <span class="ml-2">{{ pageData.localVariable[key].entityName }}</span>
            </span>
            
            <!-- Array of Objects Type -->
            <span *ngIf="getDataType(pageData.localVariable[key]) == 'ARRAY_OF_OBJECT'" class="ml-2">
              <span class="bg-indigo-100 text-indigo-800 text-xs px-2 py-1 rounded-full">Entity List</span>
              <span class="ml-2">{{ pageData.localVariable[key].entityName }}</span>
            </span>
            
            <!-- Other Types -->
            <span *ngIf="getDataType(pageData.localVariable[key]) !== 'ENTITY' && getDataType(pageData.localVariable[key]) !== 'ARRAY_OF_OBJECT'" class="ml-2">
              <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">{{getDataType(pageData.localVariable[key])}}</span>
              <span class="ml-2">{{ pageData.localVariable[key] }}</span>
            </span>
          </div>
          
          <!-- Add edit and delete buttons here if needed -->
        </div>
      </div>
    </div>
  </div>

  <!-- Image library section -->
  <div class="mb-8 bg-white rounded-lg shadow-sm">
    <div class="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
      <h2 class="text-xl font-semibold text-gray-800">Images</h2>
      <button 
        class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md transition-colors flex items-center gap-2"
        (click)="changeAddIconFlag()">
        <span class="text-lg">+</span> Add image
      </button>
    </div>
    
    <div class="p-4">
      <div *ngIf="icons.length === 0" class="text-gray-500 text-center py-4">
        No images added yet
      </div>
      
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div *ngFor="let icon of icons" class="border rounded-md p-3 hover:bg-gray-50 flex items-center gap-3">
          <img [src]="icon.url" alt="" class="w-10 h-10 object-contain rounded-md bg-gray-100">
          <span class="font-medium text-gray-800">{{ icon.name }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Save Button -->
  <div class="flex justify-center mb-6">
    <button
      class="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-8 rounded-md transition-colors shadow-sm"
      (click)="SavePageDataChanges()"
    >
      Save Changes
    </button>
  </div>
</div>

<!-- Add Local Variable Modal -->
<div
  class="h-screen w-screen fixed z-[90] top-0 left-0 bg-black/50 backdrop-blur-sm flex items-center justify-center"
  *ngIf="addLocalVariableFlag"
>
  <div class="bg-white rounded-xl shadow-xl w-[700px] max-w-[90vw] max-h-[90vh] overflow-y-auto relative">
    <div class="p-6 border-b">
      <h2 class="text-2xl font-semibold text-center">Add Local Variable</h2>
      <button 
        class="absolute top-6 right-6 text-gray-500 hover:text-gray-700" 
        (click)="changeAddLocalVariableFlag()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <div class="p-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Variable Name -->
        <div>
          <label class="block text-gray-700 font-medium mb-2">Variable Name</label>
          <input
            class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter variable name"
            [(ngModel)]="newVariableData.name"
            (keyup)="variableNameChanged()"
          />
        </div>
        
        <!-- Variable Type -->
        <div>
          <label class="block text-gray-700 font-medium mb-2">Variable Type</label>
          <select
            class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            [(ngModel)]="newVariableData.type"
            (change)="newVariableTypeChanged()"
          >
            <option value="">Select Type</option>
            <option *ngFor="let type of dataTypes">{{ type }}</option>
          </select>
        </div>
      </div>
      
      <!-- Value section -->
      <div class="mt-6" *ngIf="newVariableData.type">
        <label class="block text-gray-700 font-medium mb-2">
          {{ newVariableData.type == "ENTITY" || newVariableData.type == "ARRAY_OF_OBJECT"
              ? "Selected Entity: " + (newVariableData.value.entityId || 'None')
              : "Default Value" 
          }}
        </label>
        
        <!-- Boolean value -->
        <select
          *ngIf="newVariableData.type == 'BOOLEAN'"
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          [(ngModel)]="newVariableData.value"
          (change)="newVariableValueChanged()"
        >
          <option [value]="true">True</option>
          <option [value]="false">False</option>
        </select>
        
        <!-- String value -->
        <input
          *ngIf="newVariableData.type == 'STRING'"
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          [(ngModel)]="newVariableData.value"
          (change)="newVariableValueChanged()"
        />
        
        <!-- Number value -->
        <input
          *ngIf="newVariableData.type == 'NUMBER'"
          type="number"
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          [(ngModel)]="newVariableData.value"
          (change)="newVariableValueChanged()"
        />
        
        <!-- Entity selections -->
        <div *ngIf="newVariableData.type == 'ENTITY' || newVariableData.type == 'ARRAY_OF_OBJECT'" class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <select
            class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            [(ngModel)]="newVariableData.value.entityId"
            (change)="newVariableValueChanged()"
          >
            <option value="">Select Entity</option>
            <option *ngFor="let entity of pageDataEntity" [value]="entity.id">
              {{ entity.name }}
            </option>
          </select>
          
          <!-- <select
            class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            [(ngModel)]="newVariableData.value.entityId"
            (change)="newVariableValueChanged()"
          >
            <option value="">Select Child Entity</option>
            <option *ngFor="let entity of getNestedEntitesFlatFromEntityID(newVariableData.value.entityId)" [value]="entity.id">
              {{ entity.name }}
            </option>
          </select> -->
        </div>
      </div>
    </div>
    
    <div class="p-6 border-t bg-gray-50 flex justify-center">
      <button
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-8 rounded-md transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="!newVariableData.name || ((newVariableData.type === 'ENTITY' || newVariableData.type === 'ARRAY_OF_OBJECT') && !newVariableData.value?.entityId)"
        (click)="addLocalVariable()"
      >
        Add Variable
      </button>
    </div>
  </div>
</div>

<!-- Add image modal -->
<div
  class="h-screen w-screen fixed z-[90] top-0 left-0 bg-black/50 backdrop-blur-sm flex items-center justify-center"
  *ngIf="addIconFlag"
>
  <div class="bg-white rounded-xl shadow-xl w-[400px] max-w-[90vw] max-h-[90vh] overflow-y-auto relative">
    <div class="p-6 border-b">
      <h2 class="text-2xl font-semibold text-center">Add image</h2>
      <button 
        class="absolute top-6 right-6 text-gray-500 hover:text-gray-700" 
        (click)="changeAddIconFlag()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <div class="p-6 space-y-6">
      <!-- Icon Name -->
      <div>
        <label class="block text-gray-700 font-medium mb-2">Image Name</label>
        <input
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter image name"
          [(ngModel)]="newIcon.name"
          (change)="iconNameChanged()"
        />
      </div>
      
      <!-- Icon File Upload -->
      <div>
        <label class="block text-gray-700 font-medium mb-2">Upload image</label>
        <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center" 
             [class.bg-gray-50]="!selectedFile">
          
          <!-- File upload input -->
          <!-- Was (2026-10-16): accept=".jpg,.png,.svg" -->
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.svg,.webp,.gif"
            class="hidden"
            id="icon-upload"
            (change)="onFileChange($event)"
            #fileInput
          />
          
          <!-- No file selected state -->
          <label *ngIf="!selectedFile" for="icon-upload" class="cursor-pointer block">
            <div class="flex flex-col items-center justify-center py-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-400 mb-2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <p class="text-sm text-gray-500">
                Click to upload or drag and drop<br>
                PNG, JPEG, WebP, GIF, SVG
              </p>
              <p class="text-xs text-gray-500 mt-1">Images up to 700 KB. Larger ones are compressed; you'll see a preview first.</p>
            </div>
          </label>
          
          <!-- File selected state -->
          <div *ngIf="selectedFile" class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <!-- Image preview for images -->
              <div class="w-12 h-12 bg-gray-100 rounded border flex items-center justify-center overflow-hidden">
                <img *ngIf="filePreviewUrl" [src]="filePreviewUrl" class="max-w-full max-h-full object-contain" alt="File preview">
                <svg *ngIf="!filePreviewUrl" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-400">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
              </div>
              <!-- File name and info -->
              <div class="text-left">
                <p class="text-sm font-medium text-gray-800 truncate max-w-[180px]">{{ selectedFile.name }}</p>
                <p class="text-xs text-gray-500">{{ formatFileSize(selectedFile.size) }}</p>
              </div>
            </div>
            
            <!-- Remove file button -->
            <button 
              type="button" 
              class="p-1 rounded-full hover:bg-gray-100" 
              (click)="removeSelectedFile()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <p *ngIf="iconAddError" class="px-6 pb-4 text-sm text-red-600">{{ iconAddError }}</p>
    <div class="p-6 border-t bg-gray-50 flex justify-center">
      <button
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-8 rounded-md transition-colors cursor-pointer"
        (click)="saveIcon()"
      >
        Add image
      </button>
    </div>
  </div>
</div>
